<template>
    <div class="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <h1 class="text-2xl font-bold mb-4 text-gray-800 text-center">Welcome to Donor Registration</h1>
      <h1> {{ facilityName }}</h1> <!-- Display the facility name -->
      <div class="text-center text-gray-600 italic flex flex-col items-center">
        <!-- First line with icon at the start -->
        <div class="flex items-center mb-4">
          <i class="fas fa-hand-holding-heart text-custom-yellow text-5xl mr-2"></i>
          <p>Thanks you for your generosity and willingness to save lives through blood donation.</p>
        </div>
        
        <!-- Second line with icon at the end -->
        <div class="flex items-center">
          <p>Your contribution is invaluable, and we're excited to guide you through the process.</p>
          <i class="fas fa-heartbeat text-custom-yellow text-5xl ml-2"></i>
        </div>
      </div>
      <br />
      <br />
      <router-link
        :to="{ name: 'NewDonor', params: { facilityId: this.$route.params.facilityId } }"
        class="px-6 py-3 mt-8 bg-custom-yellow text-white font-semibold rounded-lg shadow-md hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50"
      >
        Start New Donor Registration
      </router-link>
    </div>
  </template>
  
  
  <script>
  import apiClient from '../services/api'; // Import the API client
  
  export default {
    name: "Home_",
    props: ['facilityId'],
    data() {
      return {
        facilityName: ''
        
      };
    },
    created() {
      this.fetchFacilityName();
    },
    methods: {
      async fetchFacilityName() {
        try {
          const facilityId = this.$route.params.facilityId; // Get the facility ID from the URL
          const facility = await apiClient.getFacility(facilityId); // Fetch facility data using the API client
          console.log("**facility***", facility);
          this.facilityName = facility.facility.name; // Set the facility name from the response
        } catch (error) {
          console.error("Error fetching facility:", error.message);
        }
      }
    }
  };
  </script>
  
  
  <style scoped>
    .bg-custom-yellow {
      background-color: #F8951E;
    }
  </style>
  